import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=0a6ac966"
import script from "./input-checkbox.js?vue&type=script&lang=js&external"
export * from "./input-checkbox.js?vue&type=script&lang=js&external"
import style0 from "./input-checkbox.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports